import { schema } from 'normalizr';

import { tokenSchema } from './token';

export const networkSchema = new schema.Entity('networks', { tokens: [tokenSchema] }, { idAttribute: 'shortName' });
